import { createContext, useContext } from 'react';
import type { AssetMappingResult, InsuranceMappingResult, IncentiveMappingResult, FieldMetaMap, ApplicationMappingResult } from './qc-pd-mapping';

export type SahamRowData = Record<string, unknown>;

export type QCPraPencairanContextValue = {
	fieldMeta: FieldMetaMap;
	debugFieldMeta?: boolean;
	saham: {
		data: SahamRowData[];
		meta: FieldMetaMap[];
	};
	updateSahamRow?: (index: number, row: SahamRowData) => void;
	beneficialOwnerOptions?: ApplicationMappingResult['beneficialOwnerOptions'];
	asset: Pick<AssetMappingResult, 'assetMeta' | 'customerAddress'>;
	insurance: Pick<InsuranceMappingResult, 'paymentSchedule' | 'tenorYears' | 'paymentDocumentUrl' | 'policyDocumentUrl'>;
	incentive: Pick<IncentiveMappingResult, 'distributionData' | 'showroomEmployeeOptions' | 'mandiriEmployeeOptions' | 'documentUploadUrl'>;
};

const DEFAULT_VALUE: QCPraPencairanContextValue = {
	fieldMeta: {},
	saham: { data: [], meta: [] },
	asset: {
		assetMeta: null,
		customerAddress: { alamat: '', rt: '', rw: '', kodePos: '', kelurahan: '', kecamatan: '', kota: '' },
	},
	insurance: {
		paymentSchedule: [],
		tenorYears: [],
		paymentDocumentUrl: '',
		policyDocumentUrl: '',
	},
	incentive: {
		distributionData: [],
		showroomEmployeeOptions: {},
		mandiriEmployeeOptions: {},
		documentUploadUrl: '',
	},
};

export const QCPraPencairanContext = createContext<QCPraPencairanContextValue>(DEFAULT_VALUE);

export const useQCPraPencairanData = () => useContext(QCPraPencairanContext);
